<ng-container *ngIf="isBusy">
  <span class="circle provisioning"></span>
</ng-container>
<ng-container *ngIf="!isBusy">
  {{ value | translate }}
</ng-container>
